/**
 * Checks for empty objects or arrays
 * @param obj
 * @returns
 */
function isEmpty(obj: unknown): boolean {
  return (
    // @ts-expect-error Expected
    [Object, Array].includes((obj || {}).constructor) &&
    !Object.entries(obj || {}).length
  )
}

export default isEmpty
